import { io, Socket } from 'socket.io-client';

class WebSocketService {
    private socket: Socket | null = null;
    private reconnectTimeout: NodeJS.Timeout | null = null;

    connect(token: string) {
        const websocketUrl = import.meta.env.VITE_BASE_URL;
        
        this.socket = io(websocketUrl, {
            transports: ['websocket'],
            query: { token },
            reconnection: true,
            reconnectionDelay: 1000,
        });

        this.socket.on('connect', () => {
            //console.log('Socket connected:', this.socket?.id);
        });

        this.socket.on('connect_error', (error) => {
            //console.error('Socket connection error:', error.message);
        });

        this.socket.on('disconnect', (reason) => {
            //console.log('Socket disconnected:', reason);
        });

        return this.socket;
    }

    disconnect() {
        if (this.socket) {
            this.socket.disconnect();
            this.socket = null;
        }
        
        if (this.reconnectTimeout) {
            clearTimeout(this.reconnectTimeout);
            this.reconnectTimeout = null;
        }
    }

    reconnect() {
        if (this.socket && !this.socket.connected) {
            //console.log('Attempting to reconnect socket...');
            this.socket.connect();
        }
    }

    isConnected() {
        return this.socket?.connected ?? false;
    }

    getSocket() {
        return this.socket;
    }
}

export const websocketService = new WebSocketService();